import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RestaurantMenuIcon(props: IconProps) {
    return <Icon {...props} iconKey={"restaurant_menu"}/>
}
